import request from 'local_modules/request'
import { constants } from 'helpers'
import { reducers, getState } from 'redux/core'


const setFetching = (isFetching) => reducers.marketplace.cashierConfigFoodPage.setFetching(isFetching)

const fetchClasses = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  const {
    me: { id },
    marketplace: { accessLevel: { edu, rpc } },
  } = getState()
  const { cashierAccessLevel } = !isRpc ? edu : rpc

  const schoolId = cashierAccessLevel.find(({ cashier }) => id === cashier.id).school.id

  return request.get(prefix.schools + `/${schoolId}?all=true`)
    .then(({ data }) => data)
    .then((classes) => {
      reducers.marketplace.cashierConfigFoodPage.setClasses(classes)
    })
    .catch((error) => {
      console.log(error)
    })
}

const setClasses = (classes) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  const {
    me: { id },
    marketplace: { accessLevel: { edu, rpc } },
  } = getState()
  const { cashierAccessLevel } = !isRpc ? edu : rpc

  const schoolId = cashierAccessLevel.find(({ cashier }) => id === cashier.id).school.id

  return request.post(prefix.schools + `/${schoolId}?all=true`, classes)
    .then(({ data }) => data)
    .catch((error) => {
      console.log(error)
    })
}

// список классов:
//   GET/POST http://212.22.67.82:8080/edu-0.2/environment/school/<ID>[?all=true]
//   поля json
// int id;
// String title;
// short grade;
// String letter;
// boolean active;
// school:{id : schoolId}


export default {
  setFetching,
  setClasses,
  fetchClasses,
}
